import { staffApis, StaffPatchBody } from '@apis/dashboard/staffApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchStaff = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: StaffPatchBody) => {
      const response = await staffApis.patch('/dashboard/staff/{id}/', { path: { id }, body });
      if (response[400]) {
        throw new FormError('PatchStaffError', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/staff/${id}/`]);
      },
    },
  );
};
